export const consiglioNazionaleRoma2025 = {
  id: 'static-consiglio-nazionale-roma-2025',
  slug: 'consiglio-nazionale-roma-2025',
  title: 'Consiglio Nazionale Roma 2025: Un appuntamento cruciale per il Futuro della categoria',
  excerpt: 'Il Consiglio Nazionale Studi è convocato a Roma l\'8-9 novembre 2025 presso il Belstay Hotel. Ordine del giorno: Relazione del Segretario, Progetto Formazione REAT, Rete Certificata, Indagine E-Bike. Una sfida epocale per il futuro della categoria!',
  body: `
    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.1) 0%, rgba(0, 21, 16, 0.05) 100%); border-left: 4px solid #00bf8f; padding: 1.5rem; border-radius: 12px; margin-bottom: 2rem; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-calendar-check"></i> Save the Date!
      </h3>
      <p style="margin-bottom: 0.5rem;"><strong>📅 Convocazione:</strong> Domenica 9 novembre 2025 ore 9:30</p>
      <p style="margin-bottom: 0.5rem;"><strong>📍 Sede:</strong> Belstay Hotel - Via Aurelia Km 8,400 (Via Bogliasco 27), Roma</p>
      <p style="margin-bottom: 0.5rem;"><strong>⏰ Termine Lavori:</strong> Ore 15:00 (previsto)</p>
      <p style="margin-bottom: 0;"><strong>🎯 Evento:</strong> Consiglio Nazionale Studi UNASCA</p>
    </div>

    <h2>Una Sfida Epocale per la Nostra Categoria</h2>

    <p>Carissimi Associati,</p>

    <p>Il <strong>Consiglio Nazionale Studi</strong> affronterà <strong>temi di alto profilo strategico</strong> per il futuro della nostra categoria. Siamo di fronte a una <strong>sfida epocale</strong> che richiede il coinvolgimento strutturato e consapevole di tutte le province.</p>

    <div style="background: #fff8e1; border-left: 4px solid #ffa726; padding: 1.5rem; border-radius: 8px; margin: 2rem 0;">
      <h3 style="color: #f57c00; margin-bottom: 1rem;">
        <i class="fas fa-exclamation-triangle"></i> Importanza Strategica
      </h3>
      <p style="margin-bottom: 0;">
        Il Consiglio Nazionale Studi affronterà temi di alto profilo strategico per il futuro della nostra categoria. Siamo di fronte a una <strong>sfida epocale</strong> che richiede il coinvolgimento strutturato e consapevole di tutte le province.
      </p>
    </div>

    <h2>Partecipazione e Modalità</h2>

    <p>Confidiamo nella <strong>partecipazione di tutti i responsabili delle segreterie provinciali</strong> o, in caso di impedimento, di un loro delegato, affinché il confronto possa essere ampio, costruttivo e orientato all'azione.</p>

    <div style="background: #e3f2fd; border-left: 4px solid #2196f3; padding: 1.5rem; border-radius: 8px; margin: 2rem 0;">
      <h3 style="color: #1976d2; margin-bottom: 1rem;">
        <i class="fas fa-users"></i> Chi Può Partecipare
      </h3>
      <p style="margin-bottom: 0.5rem;">
        <strong>Ai sensi dell'art. 9.5.1 dello Statuto:</strong>
      </p>
      <ul style="margin-left: 1.5rem; margin-top: 0.5rem;">
        <li>Tutti gli <strong>aventi diritto</strong> (responsabili segreterie provinciali)</li>
        <li>Gli <strong>Associati in regola</strong> con il pagamento della quota associativa 2025, previa registrazione</li>
        <li>In caso di impedimento del responsabile provinciale, è possibile delegare un rappresentante</li>
      </ul>
    </div>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1.5rem;">
        <i class="fas fa-list-check"></i> Ordine del Giorno
      </h3>

      <div style="margin-bottom: 1.5rem;">
        <h4 style="color: #001510; margin-bottom: 0.5rem;">
          <span style="background: #00bf8f; color: white; padding: 0.25rem 0.75rem; border-radius: 20px; font-size: 0.9rem; margin-right: 0.5rem;">1</span>
          Relazione del Segretario Nazionale
        </h4>
        <p style="margin-left: 2.5rem; color: #4a5568;">
          Il Segretario Nazionale Giuseppe Guarino presenterà la relazione sullo stato dell'Associazione e le prospettive future.
        </p>
      </div>

      <div style="margin-bottom: 1.5rem;">
        <h4 style="color: #001510; margin-bottom: 0.5rem;">
          <span style="background: #00bf8f; color: white; padding: 0.25rem 0.75rem; border-radius: 20px; font-size: 0.9rem; margin-right: 0.5rem;">2</span>
          Progetto Formazione REAT
        </h4>
        <p style="margin-left: 2.5rem; color: #4a5568;">
          Il nuovo Registro Unico delle Agenzie Telematiche che formalizzerà il nostro ruolo professionale, con l'introduzione della <strong>formazione obbligatoria</strong>. Un passo fondamentale per il riconoscimento della nostra categoria.
        </p>
      </div>

      <div style="margin-bottom: 1.5rem;">
        <h4 style="color: #001510; margin-bottom: 0.5rem;">
          <span style="background: #00bf8f; color: white; padding: 0.25rem 0.75rem; border-radius: 20px; font-size: 0.9rem; margin-right: 0.5rem;">3</span>
          Rete Certificata
        </h4>
        <p style="margin-left: 2.5rem; color: #4a5568;">
          Un progetto innovativo targato UNASCA per rafforzare l'immagine e la consapevolezza del nostro ruolo, sia all'interno che all'esterno della categoria. Un'iniziativa già attenzionata dal mercato e dalle Pubbliche Amministrazioni.
        </p>
      </div>

      <div style="margin-bottom: 1.5rem;">
        <h4 style="color: #001510; margin-bottom: 0.5rem;">
          <span style="background: #00bf8f; color: white; padding: 0.25rem 0.75rem; border-radius: 20px; font-size: 0.9rem; margin-right: 0.5rem;">4</span>
          Presentazione Indagine E-Bike
        </h4>
        <p style="margin-left: 2.5rem; color: #4a5568;">
          Presentazione dei risultati dell'indagine sul settore delle biciclette elettriche e le implicazioni per la nostra categoria professionale.
        </p>
      </div>

      <div>
        <h4 style="color: #001510; margin-bottom: 0.5rem;">
          <span style="background: #00bf8f; color: white; padding: 0.25rem 0.75rem; border-radius: 20px; font-size: 0.9rem; margin-right: 0.5rem;">5</span>
          Varie ed Eventuali
        </h4>
        <p style="margin-left: 2.5rem; color: #4a5568;">
          Discussione di ulteriori temi di interesse per l'Associazione e la categoria.
        </p>
      </div>
    </div>

    <h2>Il Tuo Contributo è Fondamentale</h2>

    <p>Per entrambe queste iniziative sarà <strong>necessario il coinvolgimento delle cariche territoriali</strong> e di tutti coloro che potranno dare il proprio contributo. In altre parole: <strong>c'è bisogno di tutti</strong>.</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.15) 0%, rgba(0, 21, 16, 0.08) 100%); border-radius: 12px; padding: 2rem; margin: 2rem 0; border-left: 4px solid #00bf8f;">
      <p style="font-size: 1.1rem; font-weight: 500; margin-bottom: 1rem; color: #001510;">
        💡 <strong>Il Principio Fondamentale</strong>
      </p>
      <p style="font-style: italic; color: #2d3748; line-height: 1.8;">
        "Fare qualcosa per l'Associazione significa trarne i benefici anche personalmente. Più è forte la categoria, più si rafforza il nostro ruolo e, di conseguenza, più aumenta la possibilità di avere un successo personale. Il contrario non funziona."
      </p>
      <p style="text-align: right; margin-top: 1rem; color: #00bf8f; font-weight: 600;">
        — Giuseppe Guarino, Segretario Nazionale Studi
      </p>
    </div>

    <h2>Rete Certificata UNASCA: Aderisci con Entusiasmo!</h2>

    <p>L'iniziativa della <strong>Rete Certificata</strong> è stata sviluppata con grande entusiasmo e dedizione. È un progetto nuovo che mira a:</p>

    <ul>
      <li><strong>Rafforzare l'immagine professionale</strong> della categoria</li>
      <li><strong>Aumentare la consapevolezza del nostro ruolo</strong> presso le istituzioni</li>
      <li><strong>Creare valore</strong> per tutti gli associati</li>
      <li><strong>Distinguerci sul mercato</strong> come professionisti certificati</li>
    </ul>

    <p>Vi invitiamo ad aderire con lo stesso entusiasmo che abbiamo messo noi nello sviluppo di questo progetto!</p>

    <div style="background: #f7fafc; border-radius: 12px; padding: 1.5rem; margin: 2rem 0; border: 2px solid #00bf8f;">
      <h3 style="color: #00bf8f; margin-bottom: 1rem;">
        <i class="fas fa-envelope"></i> Informazioni e Adesioni
      </h3>
      <p>Per ricevere il regolamento, il modulo d'iscrizione o per qualsiasi chiarimento sulla Rete Certificata:</p>
      <p style="text-align: center; margin: 1.5rem 0;">
        <a href="mailto:retecertificata@unasca.it" style="display: inline-block; background: #00bf8f; color: white; padding: 1rem 2rem; border-radius: 30px; text-decoration: none; font-weight: 600; box-shadow: 0 4px 15px rgba(0, 191, 143, 0.3); transition: all 0.3s;">
          📧 retecertificata@unasca.it
        </a>
      </p>
    </div>

    <h2>Convenzione Alberghiera</h2>

    <p>Per agevolare la partecipazione di tutti i Soci interessati, l'Associazione ha stipulato un accordo con il <strong>Belstay Roma Aurelia</strong> con tariffe vantaggiose:</p>

    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1.5rem; margin: 2rem 0;">
      <div style="background: white; border-radius: 12px; padding: 1.5rem; box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08); text-align: center;">
        <div style="font-size: 2.5rem; margin-bottom: 0.5rem;">🛏️</div>
        <h4 style="color: #00bf8f; margin-bottom: 0.5rem;">Camera Singola</h4>
        <p style="font-size: 1.8rem; font-weight: 700; color: #001510; margin: 0;">€ 120,00</p>
        <p style="font-size: 0.9rem; color: #718096; margin-top: 0.25rem;">doppia uso singola</p>
      </div>

      <div style="background: white; border-radius: 12px; padding: 1.5rem; box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08); text-align: center;">
        <div style="font-size: 2.5rem; margin-bottom: 0.5rem;">🛏️🛏️</div>
        <h4 style="color: #00bf8f; margin-bottom: 0.5rem;">Camera Doppia</h4>
        <p style="font-size: 1.8rem; font-weight: 700; color: #001510; margin: 0;">€ 135,00</p>
        <p style="font-size: 0.9rem; color: #718096; margin-top: 0.25rem;">per camera</p>
      </div>
    </div>

    <div style="background: #fff5f5; border-left: 4px solid #f56565; padding: 1.5rem; border-radius: 12px; margin: 2rem 0;">
      <h4 style="color: #c53030; margin-bottom: 1rem;">
        <i class="fas fa-info-circle"></i> Importante
      </h4>
      <p style="margin-bottom: 0;">Ogni aspetto riguardante il soggiorno dovrà essere trattato e definito <strong>direttamente con l'albergo</strong>.</p>
    </div>

    <h3>Contatti per Prenotazioni</h3>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <p style="margin-bottom: 1rem;"><strong>Ada Massaroni</strong> – Event Manager Belstay Roma Aurelia</p>
      <p style="margin-bottom: 0.5rem;">
        <i class="fas fa-phone" style="color: #00bf8f; margin-right: 0.5rem;"></i>
        <strong>Tel:</strong> <a href="tel:+390666509506" style="color: #00bf8f; text-decoration: none;">+39 06 66509506</a>
      </p>
      <p style="margin-bottom: 0;">
        <i class="fas fa-envelope" style="color: #00bf8f; margin-right: 0.5rem;"></i>
        <strong>Email:</strong> <a href="mailto:a.massaroni@belstayhotels.it" style="color: #00bf8f; text-decoration: none;">a.massaroni@belstayhotels.it</a>
      </p>
    </div>

    <div style="text-align: center; margin: 3rem 0;">
      <img src="/images/belstay.jpg" alt="Belstay Roma Aurelia" style="width: 100%; max-width: 800px; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);">
    </div>

    <h2>La Tua Presenza Fa la Differenza</h2>

    <p>Vi invitiamo a <strong>tenere libera la data del 9 novembre</strong> e a partecipare numerosi. Sarà un Consiglio di straordinaria importanza per il futuro della nostra categoria.</p>

    <p>I lavori termineranno presumibilmente alle <strong>ore 15:00 di domenica 9 novembre</strong>.</p>

    <div style="background: linear-gradient(135deg, #00bf8f 0%, #001510 100%); color: white; border-radius: 12px; padding: 2rem; margin: 3rem 0; text-align: center; box-shadow: 0 15px 40px rgba(0, 191, 143, 0.3);">
      <h3 style="color: white; margin-bottom: 1rem; font-size: 1.5rem;">
        🤝 Insieme Siamo Più Forti
      </h3>
      <p style="font-size: 1.1rem; line-height: 1.8; margin-bottom: 1rem;">
        Il successo dell'Associazione è il successo di ciascuno di noi.<br>
        La tua partecipazione e il tuo contributo sono fondamentali per costruire insieme il futuro della nostra professione.
      </p>
      <p style="font-size: 1rem; line-height: 1.6; margin-bottom: 0; font-style: italic;">
        "Confido nella partecipazione di tutti i responsabili delle segreterie provinciali o, in caso di impedimento, di un loro delegato, affinché il confronto possa essere ampio, costruttivo e orientato all'azione."
      </p>
    </div>

    <div style="margin-top: 3rem; padding-top: 2rem; border-top: 2px solid #e2e8f0;">
      <p style="text-align: center; color: #4a5568; font-style: italic; margin-bottom: 2rem;">
        Ci vediamo a Roma il 9 novembre!
      </p>
      <p style="text-align: right;"><strong>Cordiali saluti.</strong></p>
      <br>
      <p style="text-align: right;"><strong>Il Segretario Nazionale Studi<br>Giuseppe Guarino</strong></p>
    </div>
  `,
  featuredImage: '/images/belstay.jpg',
  category: {
    id: 'eventi',
    name: 'Eventi',
    slug: 'eventi',
    color: '#8B5CF6'
  },
  tags: ['Consiglio Nazionale', 'Roma 2025', 'ReAT', 'Rete Certificata', 'Formazione', 'Eventi'],
  author: {
    id: 'unasca-presidenza',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-09-15T10:00:00Z',
  createdAt: '2025-09-15T10:00:00Z',
  updatedAt: '2025-09-15T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 6
};

